<template>
<div >
  <v-card class='elevation-10'>

    <!-- background picture -->
    <v-dialog v-model='backgroundDialog' fullscreen >
      <v-card flat>
        <v-card-title class='grey lighten-4 py-0' >
          Choose a background picture
          <v-spacer/>
          <v-btn @click='backgroundDialog=false' icon ><v-icon>close</v-icon></v-btn>
        </v-card-title>
        <image-search
          v-model='profile.background_picture'
          title='Search for an image'
          @input='saveBackground' >
        </image-search>
      </v-card>
    </v-dialog>
    <v-img height='250'
      :src='backgroundPicture' >
      <v-card-title
        class='title pl-4 white--text'
        style="background-color: rgba(0, 0, 0, 0.6);" >
        {{me.first_name}} {{me.last_name}}
        <v-spacer />
        <v-btn dark icon small @click='getMe' :loading='getMeReq.loading' >
          <v-icon small dark >replay</v-icon>
        </v-btn>
      </v-card-title >
      <v-card-actions >
        <v-spacer/>
        <v-btn  small dark class='mb-5' @click="logoDialog=true" >
          Change profile picture
        </v-btn>
        <v-btn small dark class='mb-5' @click="backgroundDialog=true" >
          Change background picture
        </v-btn>
      </v-card-actions>
    </v-img>

    <!-- profile pic -->
    <!-- <div absolute
      class='ml-5'
      width='200' height='180'
      style='margin-top:-70px;padding-left:50px;'
      @click='logoDialog=true' > -->



    <!-- </div> -->

  </v-card>
  <v-avatar absolute
    v-if='profile.profile_picture'
    style='margin-top:-120px;margin-left:50px;'
    class='elevation-10' :size='180'
    @click='logoDialog=true' >
    <v-progress-circular v-if='getMeReq.loading' indeterminate color='amber' :size=100 >
    </v-progress-circular>
    <v-img v-else :src='profile.profile_picture' height='180' width='180' />
  </v-avatar>


  <v-dialog v-model='logoDialog' width='400' >
    <v-card flat >
      <v-card-title class='grey lighten-4 py-0' >
        Update your Profile picture
        <v-spacer/>
        <v-btn @click='logoDialog=false' icon ><v-icon>close</v-icon></v-btn>
      </v-card-title>
      <uploader
        @uploadsuccess='getMe();logoDialog=false'
        :path='profilePath'
        filename='profile_picture' >
        <template slot='gallery' slot-scope="props">
          <v-subheader>Examples of how this may look in various places</v-subheader>
          <v-layout v-for='(img, index) in props.images' :key="index" >
            <v-flex>
              <v-subheader>Avatar view</v-subheader>
              <v-avatar ><img :src="img" /></v-avatar></v-flex>
            <v-flex>
              <v-subheader>Normal view</v-subheader>
              <img :src="img" /></v-flex>
          </v-layout>
        </template>
      </uploader>
    </v-card>
  </v-dialog>

  <!-- forms -->
  <v-card class='mt-3' tile >
    <request-status :request='requests.me' />
    <v-card-title class="overline" >
      Contact details
    </v-card-title>
    <v-divider />
    <v-card-text>
      <v-layout row wrap >
        <v-flex
          v-for='field in contactsForm'
          :class='field.flexClass'
          :key='field.label' >

          <v-divider v-if='field.type === "divider"' ></v-divider>

          <v-text-field v-else
            :hint='field.hint' :label='field.label'
            :multi-line='field.multiLine'
            :error-messages='getErrors(requests.me, field.model)'
            v-model='me[field.model]' />

          <!-- :error-messages='getObjectPath(requests.me.errors, field)' -->
        </v-flex>
      </v-layout>
    </v-card-text>
    <v-card-actions>
      <v-btn flat @click='getMe' :loading='getMeReq.loading' >Reset</v-btn>
      <v-spacer></v-spacer>
      <v-btn @click='saveMe' :loading='requests.me.loading' color='primary' >Save</v-btn>
    </v-card-actions>
    <!-- <pre v-text='mePayload' /> -->
  </v-card>

  <v-card class='mt-3' >
    <request-status :request='requests.profile' />
    <v-card-title class="overline" >
      Extra information
    </v-card-title>
    <v-divider />
    <v-card-text>
      <profession-picker v-model='profile.profession' />
      <!-- <pre v-text='profile.profession' /> -->
      <template v-for='field in extrasForm' >

        <v-divider v-if='field.type === "divider"' :key='field.label' ></v-divider>
        <v-checkbox v-else-if='field.type === "checkbox"'
            :label='field.label'
            :error-messages='getErrors(requests.me, field.model)'
            v-model="profile[field.model]" />

        <component
          v-else-if="field.component"
          :is="field.component"
          :attrs="field.attrs"
          v-model='profile[field.model]' />

        <v-text-field v-else :key='field.label'
          :hint='field.hint' :label='field.label'
          :multi-line='field.multiLine'
          :error-messages='getErrors(requests.profile, field.model)'
          v-model='profile[field.model]' ></v-text-field>
          <!-- :error-messages='getObjectPath(requests.profile.errors, field)' -->

      </template>
    </v-card-text>
    <v-card-actions>
      <v-btn flat @click='getMe' :loading='getMeReq.loading' >Reset</v-btn>
      <v-spacer></v-spacer>
      <v-btn @click='saveExtras' :loading='requests.profile.loading' color='primary' >Save</v-btn>
    </v-card-actions>
  </v-card>

  <v-card class='mt-3' >
    <request-status :request='requests.profile' />
    <v-card-title class="overline" >
      Social's
    </v-card-title>
    <v-divider />
    <v-card-text>
      <template v-for='field in socialsForm' >
        <v-divider v-if='field.type === "divider"' :key='field.label' ></v-divider>
        <v-text-field v-else :key='field.label'
          :hint='field.hint' :label='field.label'
          :multi-line='field.multiLine'
          :error-messages='getErrors(requests.profile, field.model)'
          v-model='profile[field.model]' />
          <!-- :error-messages='getObjectPath(requests.profile.errors, field)' -->
      </template>
    </v-card-text>
    <v-card-actions>
      <v-btn flat @click='getMe' :loading='getMeReq.loading' >Reset</v-btn>
      <v-spacer></v-spacer>
      <v-btn @click='saveSocials' :loading='requests.profile.loading' color='primary' >Save</v-btn>
    </v-card-actions>
  </v-card>

  <!-- <v-card class='mt-3' >
    <v-card-title>
      <h2 class="overline" >Preferences</h2>
    </v-card-title>
    <v-divider></v-divider>
    <v-card-text >
      <div>
        <v-switch persistent-hint
          v-model='enableEarlyAccess'
          @change='toggleEarlyAccess'
          label='Opt into version 2 preview'
          hint="We're working on a new app. You can try it out if you like" />
      </div>
    </v-card-text>
  </v-card> -->

  <!-- <pre>{{profile}}</pre> -->
  <v-card class='mt-3' >
    <v-card-title>
      <h2 class='overline' >Change your password</h2>
    </v-card-title>
    <v-divider></v-divider>
    <v-card-text >

      <v-text-field
      label="Enter a new password"
      hint="At least 8 characters"
      v-model="password"
      min="8"
      @click:append='passwordVisible = !passwordVisible'
      :loading='changePasswordReq.loading'
      :append-icon="passwordVisible ? 'visibility' : 'visibility_off'"
      :type="passwordVisible ? 'password' : 'text'"
      counter ></v-text-field>

    </v-card-text>
    <v-card-actions>
    <v-spacer></v-spacer>
    <vuex-btn @save='changePassword' :req-id='changePassReqId' text='Save' ></vuex-btn>
    </v-card-actions>
  </v-card>
</div>
</template>

<script>
import Vue from 'vue'
import ServerErrors from '@/components/ServerErrors'
import RequestsMixin from '@/mixins/requests'
import Uploader from '@/components/pages/settings/media/Uploader.vue'
import ImageSearch from '@/components/ui/ImageSearch'
import ProfessionPicker from '@/components/pickers/ProfessionPicker.vue'

export default {
  name: 'Profile',
  mixins: [RequestsMixin],
  components: {ServerErrors, Uploader, ImageSearch, ProfessionPicker},
  data () {
    return {
      password: null,
      passwordVisible: false,
      backgroundDialog: false,
      logoDialog: false,
      enableEarlyAccess: false,
      changePassReqId: 'practitioner-password-change',
      requests: {
        me: { resource: 'ag.user', errors: {} },
        profile: { resource: 'ag.practitioner.me.profile', errors: {} }
      }
    }
  },
  mounted () {
    if (this.$cookies.get('nf_ab') === 'next') {
      this.enableEarlyAccess = true
    }
    if (this.me && this.me.profile) {
      // this.profile = this.me.profile
      for (let key of Object.keys(this.me.profile)) {
        Vue.set(this.profile, key, this.me.profile[key])
      }
    }
  },
  watch: {
    saveRequestStatus () {
      if (this.saveRequestStatus === 200) {
        this.getMe()
      }
    }
  },
  methods: {
    getPayload (form, obj) {
      let keys = form.map((field) => { return field.model })
      let payload = {}
      keys.forEach((key) => {
        payload[key] = obj[key]
      })
      return payload
    },
    saveMe () {
      this.requests.me.data = this.getPayload(this.contactsForm, this.me)
      this.requests.me.resourceId = this.meId
      this.$request('save', this.requests.me)
    },
    getErrors (req, field) {
      return this.getObjectPath(req, `errors.${field}`, [])
    },
    saveExtras () {
      let professionId = this.getObjectPath(this.profile, 'profession.id')
      this.requests.profile.data = this.getPayload(this.extrasForm, this.profile)
      this.requests.profile.data.profession = professionId
      this.requests.profile.resourceId = this.meId
      this.$request('save', this.requests.profile)
    },
    saveSocials () {
      this.requests.profile.data = this.getPayload(this.socialsForm, this.profile)
      this.requests.profile.resourceId = this.meId
      this.$request('save', this.requests.profile)
    },
    saveBackground () {
      this.requests.profile.data = {background_picture: this.profile.background_picture}
      this.requests.profile.resourceId = this.meId
      this.$request('save', this.requests.profile)
      this.backgroundDialog = false
    },
    changePassword () {
      let options = {
        id: this.changePassReqId,
        data: {
          password: this.password
        }
      }
      this.$appointmentguru
        .endpoint('auth-set-password', options)
    },
    toggleEarlyAccess () {
      if (this.enableEarlyAccess === true) {
        this.$cookies.set('nf_ab', 'next', '30d')
        let withRefresh = window.confirm('You have opted into early access. Would you like to refresh the app to load the new version now?')
        if (withRefresh) { window.location.reload() }
      } else {
        this.$cookies.remove('nf_ab')
      }
    }
  },
  computed: {
    me () {
      return this.$store.getters.me
    },
    // meId () { return this.getObjectPath(this.me, 'id') },
    profile () { return this.getObjectPath(this.me, 'profile', {}) },
    profilePath () { return '/api/v2/practitioner/me/profile/' + this.meId + '/' },
    changePasswordReq () {
      return this.$store.getters.getRequestById(this.changePassReqId, true)
    },
    backgroundPicture () {
      let bg = this.getObjectPath(this.profile, 'background_picture')
      if (!bg) {
        bg = 'https://images.unsplash.com/photo-1530543787849-128d94430c6b?ixid=MXwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHw%3D&ixlib=rb-1.2.1&auto=format&fit=crop&w=1950&q=80'
      }
      return bg
    },
    contactsForm () {
      return [
        {
          label: 'First name',
          model: 'first_name',
          flexClass: 'xs6'
        },
        {
          label: 'Last name',
          model: 'last_name',
          flexClass: 'xs6'
        },
        {
          label: 'Email',
          model: 'email',
          flexClass: 'xs6'
        },
        {
          label: 'Phone number',
          model: 'phone_number',
          hint: 'A valid phone number starting with the country code. e.g.: +27831111111',
          flexClass: 'xs6'
        }
      ]
    },
    extrasForm () {
      return [
        {
          label: 'Registration number',
          model: 'registration_number',
          hint: 'Your personal professional registration number. For example, a BK number.'
        },
        {
          label: 'Description',
          model: 'description',
          hint: 'A short professional bio'
        },
        {
          label: 'Timezone',
          model: 'timezone',
          hint: 'The timezone in which you work'
        },
        {
          label: 'Grant customer support access to my account',
          type: 'checkbox',
          model: 'allow_become',
          hint: 'Allow AppointmentGuru customer support access to your account so that they can perform actions on your behalf'
        }
      ]
    },
    socialsForm () {
      return [
        // {
        //   label: 'Banking details',
        //   hint: 'We\'ll use your banking details in your invoices',
        //   model: 'banking_details',
        //   multiLine: true
        // }
        {
          label: 'Facebook page',
          model: 'facebook',
          hint: 'The url to your Facebook page'
        },
        {
          label: 'Linkedin',
          model: 'linkedin',
          hint: 'The url to your linkedin page'
        },
        {
          label: 'Instagram',
          model: 'instagram',
          hint: 'The url to your instagram account'
        },
        {
          label: 'Twitter',
          model: 'twitter',
          hint: 'The url to your twitter profile'
        }
      ]
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// Profile.vue?4955a346